"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicePlanTemplateListResponseSchema = exports.servicePlanListResponseSchema = exports.servicePlanListQuerySchema = exports.servicePlanEnrollmentSchema = exports.servicePlanOccurrenceSchema = exports.servicePlanTemplateSchema = exports.servicePlanTemplateLineSchema = exports.updateServicePlanEnrollmentStatusRequestSchema = exports.servicePlanEnrollmentActionSchema = exports.createServicePlanEnrollmentRequestSchema = exports.updateServicePlanTemplateStatusRequestSchema = exports.createServicePlanTemplateRequestSchema = exports.servicePlanTemplateLineInputSchema = exports.servicePlanRecurrenceSchema = exports.servicePlanOccurrenceStatusSchema = exports.servicePlanEnrollmentStatusSchema = exports.servicePlanTemplateStatusSchema = exports.servicePlanFrequencySchema = exports.servicePlanOccurrenceIdSchema = exports.servicePlanEnrollmentIdSchema = exports.servicePlanTemplateIdSchema = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
exports.servicePlanTemplateIdSchema = zod_1.z.string().uuid();
exports.servicePlanEnrollmentIdSchema = zod_1.z.string().uuid();
exports.servicePlanOccurrenceIdSchema = zod_1.z.string().uuid();
exports.servicePlanFrequencySchema = zod_1.z.enum(["WEEKLY", "MONTHLY"]);
exports.servicePlanTemplateStatusSchema = zod_1.z.enum(["ACTIVE", "ARCHIVED"]);
exports.servicePlanEnrollmentStatusSchema = zod_1.z.enum([
    "ACTIVE",
    "PAUSED",
    "CANCELED",
]);
exports.servicePlanOccurrenceStatusSchema = zod_1.z.enum([
    "PENDING",
    "GENERATED",
    "SKIPPED",
    "FAILED",
]);
const optionalText = (maxLength) => zod_1.z
    .string()
    .trim()
    .max(maxLength)
    .optional()
    .transform((value) => value || undefined);
const quantityMilliSchema = zod_1.z.number().int().min(1).max(1_000_000);
exports.servicePlanRecurrenceSchema = zod_1.z.object({
    frequency: exports.servicePlanFrequencySchema,
    interval: zod_1.z.number().int().min(1).max(12),
});
exports.servicePlanTemplateLineInputSchema = zod_1.z.object({
    catalogItemId: zod_1.z.string().uuid(),
    quantityMilli: quantityMilliSchema.default(1_000),
});
exports.createServicePlanTemplateRequestSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(2).max(160),
    description: optionalText(2_000),
    recurrence: exports.servicePlanRecurrenceSchema,
    defaultDurationMinutes: zod_1.z.number().int().min(15).max(1_440),
    lineItems: zod_1.z
        .array(exports.servicePlanTemplateLineInputSchema)
        .min(1)
        .max(100)
        .refine((items) => new Set(items.map((item) => item.catalogItemId)).size === items.length, { message: "A price book item can appear only once." }),
});
exports.updateServicePlanTemplateStatusRequestSchema = zod_1.z.object({
    status: exports.servicePlanTemplateStatusSchema,
});
exports.createServicePlanEnrollmentRequestSchema = zod_1.z.object({
    templateId: exports.servicePlanTemplateIdSchema,
    customerId: zod_1.z.string().uuid(),
    serviceLocationId: zod_1.z.string().uuid(),
    businessLocationId: zod_1.z.string().uuid().optional(),
    assignedMembershipId: zod_1.z.string().uuid().optional(),
    firstServiceAt: zod_1.z.string().datetime({ offset: true }),
});
exports.servicePlanEnrollmentActionSchema = zod_1.z.enum([
    "PAUSE",
    "RESUME",
    "CANCEL",
]);
exports.updateServicePlanEnrollmentStatusRequestSchema = zod_1.z.object({
    action: exports.servicePlanEnrollmentActionSchema,
});
exports.servicePlanTemplateLineSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    catalogItemId: zod_1.z.string().uuid(),
    position: zod_1.z.number().int().nonnegative(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    type: zod_1.z.enum(["SERVICE", "MATERIAL"]),
    pricingUnit: zod_1.z.enum(["FLAT_RATE", "HOUR", "EACH"]),
    quantityMilli: quantityMilliSchema,
    unitPriceCents: zod_1.z.number().int().nonnegative(),
    unitCostCents: zod_1.z.number().int().nonnegative().nullable(),
    taxable: zod_1.z.boolean(),
    lineTotalCents: zod_1.z.number().int().nonnegative(),
});
exports.servicePlanTemplateSchema = zod_1.z.object({
    id: exports.servicePlanTemplateIdSchema,
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    status: exports.servicePlanTemplateStatusSchema,
    recurrence: exports.servicePlanRecurrenceSchema,
    defaultDurationMinutes: zod_1.z.number().int().positive(),
    lineItems: zod_1.z.array(exports.servicePlanTemplateLineSchema),
    enrollmentCount: zod_1.z.number().int().nonnegative(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.servicePlanOccurrenceSchema = zod_1.z.object({
    id: exports.servicePlanOccurrenceIdSchema,
    scheduledStartAt: zod_1.z.string().datetime(),
    scheduledEndAt: zod_1.z.string().datetime(),
    status: exports.servicePlanOccurrenceStatusSchema,
    generatedJobId: zod_1.z.string().uuid().nullable(),
    generatedAt: zod_1.z.string().datetime().nullable(),
    lastError: zod_1.z.string().nullable(),
});
exports.servicePlanEnrollmentSchema = zod_1.z.object({
    id: exports.servicePlanEnrollmentIdSchema,
    status: exports.servicePlanEnrollmentStatusSchema,
    template: zod_1.z.object({
        id: exports.servicePlanTemplateIdSchema,
        name: zod_1.z.string(),
        recurrence: exports.servicePlanRecurrenceSchema,
    }),
    customer: zod_1.z.object({ id: zod_1.z.string().uuid(), displayName: zod_1.z.string() }),
    serviceLocation: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        name: zod_1.z.string(),
        addressLine1: zod_1.z.string(),
        city: zod_1.z.string(),
        state: zod_1.z.string(),
        postalCode: zod_1.z.string(),
        timezone: zod_1.z.string(),
    }),
    businessLocationId: zod_1.z.string().uuid(),
    assignedMembershipId: zod_1.z.string().uuid().nullable(),
    nextOccurrence: exports.servicePlanOccurrenceSchema.nullable(),
    pausedAt: zod_1.z.string().datetime().nullable(),
    canceledAt: zod_1.z.string().datetime().nullable(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.servicePlanListQuerySchema = zod_1.z.object({
    search: zod_1.z.string().trim().max(160).optional(),
    status: exports.servicePlanEnrollmentStatusSchema.optional(),
    customerId: zod_1.z.string().uuid().optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    cursor: zod_1.z.string().trim().min(1).max(512).optional(),
});
exports.servicePlanListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.servicePlanEnrollmentSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.servicePlanTemplateListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.servicePlanTemplateSchema),
    total: zod_1.z.number().int().nonnegative(),
});
//# sourceMappingURL=service-plan.js.map